import { render, staticRenderFns } from "./indexEdit.vue?vue&type=template&id=b861c77a&scoped=true&"
import script from "./indexEdit.vue?vue&type=script&lang=js&"
export * from "./indexEdit.vue?vue&type=script&lang=js&"
import style0 from "./indexEdit.vue?vue&type=style&index=0&id=b861c77a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b861c77a",
  null
  
)

export default component.exports